import SiHaDocumentationStatusListResultModelBase from '../_generated/modelBases/si-ha-documentation-status-list-result-model-base';

export default class SiHaDocumentationStatusListResultModel extends SiHaDocumentationStatusListResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
